export default __webpack_public_path__ + "static/media/icon.557c94f3.png";